module.exports = __webpack_public_path__ + "img/id.d89ff941.svg";